import tw from 'twin.macro';

export const StateItemContent = tw.div`min-w-[3.75rem] w-full flex flex-col items-start justify-center gap-2 transition duration-75 ease-in`;

export const StateItemInfo = tw.div`flex items-center justify-between gap-2`;

export const StateItemInfoImage = tw.img`w-[1.313rem] h-[1.313rem] object-contain`;
